import { withTranslation } from "react-i18next";

import FnbInfo from './FnbInfo';

export default withTranslation()(FnbInfo);